<div class="calendar-dialog">

  <!-- Header -->
  <div class="dialog-header">
    <h2>Agendar Cita</h2>
    <button class="close-btn" (click)="closeDialog()">✕</button>
  </div>

  <!-- Error / Success messages -->
  <div *ngIf="errorMessage" class="message error">{{ errorMessage }}</div>
  <div *ngIf="successMessage" class="message success">{{ successMessage }}</div>

  <!-- ============================================ -->
  <!-- Calendario listo -->
  <!-- ============================================ -->
  <div *ngIf="isCalendarReady" class="calendar-section">

    <!-- FullCalendar -->
    <div class="calendar-wrapper">
      <full-calendar [options]="calendarOptions"></full-calendar>
    </div>

    <!-- Instrucción -->
    <p class="hint">Haz clic en un día o selecciona un rango de horas para agendar una cita.</p>

    <!-- ============================================ -->
    <!-- Formulario inline para nueva cita -->
    <!-- ============================================ -->
    <div *ngIf="showNewAppointmentForm" class="new-appointment-form">
      <div class="form-header">
        <h3>Nueva Cita</h3>
        <span class="selected-date">{{ selectedDateDisplay }}</span>
      </div>

      <div class="form-group">
        <label for="newTitle">Título *</label>
        <input id="newTitle" type="text" [(ngModel)]="newAppointmentTitle" placeholder="Ej: Reunión con cliente" />
      </div>

      <div class="form-group">
        <label for="newLocation">Ubicación</label>
        <input id="newLocation" type="text" [(ngModel)]="newAppointmentLocation" placeholder="Ej: Oficina principal" />
      </div>

      <div class="form-group">
        <label for="newDescription">Descripción</label>
        <textarea id="newDescription" [(ngModel)]="newAppointmentDescription" rows="2" placeholder="Detalles de la cita..."></textarea>
      </div>

      <div class="form-actions">
        <button class="btn-cancel" (click)="cancelAppointment()">Cancelar</button>
        <button class="btn-create" (click)="createAppointment()" [disabled]="isLoading || !newAppointmentTitle">
          {{ isLoading ? 'Creando...' : 'Agendar Cita' }}
        </button>
      </div>
    </div>

  </div>

</div>
